import { render } from "./PlayerStats.vue?vue&type=template&id=1a5b25f4"
import script from "./PlayerStats.vue?vue&type=script&lang=js"
export * from "./PlayerStats.vue?vue&type=script&lang=js"

import "./PlayerStats.vue?vue&type=style&index=0&id=1a5b25f4&lang=css"

import exportComponent from "/tmp/build_4e4571bb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__